var _style, _path, _polygon, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 540 344",
    style: {
      enableBackground: "new 0 0 540 344"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000009569023476938287080000002784333823483092630_);}\r\n\t.st2{fill:url(#SVGID_00000114789217154141046870000009829746692344260286_);}\r\n\t.st3{fill:url(#SVGID_00000141428821550556806780000013878673710691816849_);}\r\n\t.st4{fill:url(#SVGID_00000012457116213049890380000017413170318352085945_);}\r\n\t.st5{fill:url(#SVGID_00000047764713670638640670000015632014447757949068_);}\r\n\t.st6{fill:url(#SVGID_00000174604311438292491210000010355702736053097137_);}\r\n\t.st7{fill:url(#SVGID_00000000931016126964167980000009080679935341285299_);}\r\n\t.st8{fill:url(#SVGID_00000054226773444362169290000005878581978092766632_);}\r\n\t.st9{fill:url(#SVGID_00000107552324619881249450000013275743258109128600_);}\r\n\t.st10{fill:url(#SVGID_00000085212709718228947710000003368508745180707985_);}\r\n\t.st11{fill:url(#SVGID_00000127750629722348995080000007653506269580180124_);}\r\n\t.st12{fill:url(#SVGID_00000063622056045229407700000003746177694698154669_);}\r\n\t.st13{fill:url(#SVGID_00000140010239554385357620000006846991568521719218_);}\r\n\t.st14{fill:url(#SVGID_00000094614668618086118810000013898393034334059174_);}\r\n\t.st15{fill:url(#SVGID_00000134930616592662460240000006816472156813009846_);}\r\n\t.st16{fill:url(#SVGID_00000092432203156027281070000000969175493579038632_);}\r\n\t.st17{fill:url(#SVGID_00000032623650248104559550000002783258018908837301_);}\r\n\t.st18{fill:#020203;}\r\n\t.st19{fill:url(#SVGID_00000003785064901173659780000005139892699659572120_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.3,
    y1: 116.1756,
    x2: 39.3,
    y2: 166.7756,
    gradientTransform: "matrix(1 0 0 -1 0 345.2756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817116,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5637,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7C8AF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.2,179.7c0,16.5,0,32.9,0,49.4h-2.6v-50.6H47c-0.4,0.4-0.7,0.8-1.1,1.2H34.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137127130906523681170000005483505439833968007_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.35,
    y1: 116.1756,
    x2: 54.35,
    y2: 167.5756,
    gradientTransform: "matrix(1 0 0 -1 0 345.2756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817116,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5637,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7C8AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137127130906523681170000005483505439833968007_)"
    },
    d: "M69.2,229.1h-2.6 c-4.3-15.5-8.6-31.1-12.9-46.6c-4.3,15.5-8.6,31.1-12.9,46.6h-1.3c4.5-16.3,9-32.7,13.5-49c0.7-0.8,1.3-1.6,2-2.4 C59.8,194.8,64.5,212,69.2,229.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018951023051424117440000002145089922360924832_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.4,
    y1: 115.3756,
    x2: 95.4,
    y2: 167.5756,
    gradientTransform: "matrix(1 0 0 -1 0 345.2756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817116,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5637,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7C8AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018951023051424117440000002145089922360924832_)"
    },
    d: "M122.3,203.8c0,14.4-12,26.1-26.9,26.1 s-26.9-11.7-26.9-26.1s12-26.1,26.9-26.1C110.2,177.7,122.3,189.4,122.3,203.8z M112.6,187.1c-10-9.7-25.8-10.1-35.3-0.9 c-9.5,9.2-9.1,24.6,0.9,34.3s25.8,10.1,35.3,0.9C123,212.1,122.6,196.8,112.6,187.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124148631038243872500000009198393152841735333_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.1,
    y1: 115.3756,
    x2: 136.1,
    y2: 166.7756,
    gradientTransform: "matrix(1 0 0 -1 0 345.2756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817116,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5637,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7C8AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124148631038243872500000009198393152841735333_)"
    },
    d: "M146.9,213.9c0,8.8-7.4,16-16.5,16 c-1.8,0-3.5-0.3-5.1-0.8v-50.6h15.3c-0.4,0.4-0.7,0.7-1.1,1.1h-11.7v18.6c0.8-0.1,1.7-0.2,2.5-0.2 C139.5,197.9,146.9,205.1,146.9,213.9z M144.4,213.9c0-8.1-6.2-14.7-13.9-14.7c-0.9,0-1.7,0.1-2.5,0.3v29c0.8,0.2,1.7,0.3,2.5,0.3 C138.1,228.6,144.4,222,144.4,213.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031915645576265995020000009020725718802704264_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.85,
    y1: 116.1756,
    x2: 161.85,
    y2: 167.5756,
    gradientTransform: "matrix(1 0 0 -1 0 345.2756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817116,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5637,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7C8AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031915645576265995020000009020725718802704264_)"
    },
    d: "M176.7,229.1H174 c-1.7-6.2-3.4-12.5-5.2-18.7h-15.4c-1.7,6.2-3.4,12.5-5.2,18.7H147c4.5-16.3,9-32.7,13.5-49c0.7-0.8,1.3-1.6,2-2.4 C167.2,194.8,171.9,212,176.7,229.1z M168.5,209.1l-7.4-26.7l-7.4,26.7H168.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021817806323846030530000004505174212703693750_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.55,
    y1: 116.1756,
    x2: 194.55,
    y2: 167.5756,
    gradientTransform: "matrix(1 0 0 -1 0 345.2756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817116,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5637,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7C8AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021817806323846030530000004505174212703693750_)"
    },
    d: "M209.4,229.1h-2.6 c-4.3-15.5-8.6-31.1-12.9-46.6c-4.3,15.5-8.6,31.1-12.9,46.6h-1.3c4.5-16.3,9-32.7,13.5-49c0.7-0.8,1.3-1.6,2-2.4 C199.9,194.8,204.7,212,209.4,229.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023995307909623531770000007866256936134288569_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.2,
    y1: 115.3756,
    x2: 223.2,
    y2: 166.7756,
    gradientTransform: "matrix(1 0 0 -1 0 345.2756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817116,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5637,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7C8AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023995307909623531770000007866256936134288569_)"
    },
    d: "M234,213.9c0,8.8-7.4,16-16.5,16 c-1.8,0-3.5-0.3-5.1-0.8v-50.6h2.6v19.6c0.8-0.1,1.7-0.2,2.5-0.2C226.6,197.9,234,205.1,234,213.9z M231.5,213.9 c0-8.1-6.2-14.7-13.9-14.7c-0.9,0-1.7,0.1-2.5,0.3v29c0.8,0.2,1.7,0.3,2.5,0.3C225.2,228.6,231.5,222,231.5,213.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121986435670520216220000013406118233982229378_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.8,
    y1: 116.1756,
    x2: 247.8,
    y2: 166.7756,
    gradientTransform: "matrix(1 0 0 -1 0 345.2756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817116,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5637,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7C8AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121986435670520216220000013406118233982229378_)"
    },
    d: "M237.1,229.1v-50.6h2.5v29.9H256v-29.9 h2.5v50.6H256v-19.5h-16.4v19.5H237.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016041803786730938550000003964805949800650161_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.75,
    y1: 115.3756,
    x2: 275.75,
    y2: 166.7756,
    gradientTransform: "matrix(1 0 0 -1 0 345.2756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817116,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5637,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7C8AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016041803786730938550000003964805949800650161_)"
    },
    d: "M283.2,213.9c0,8.8-7.4,16-16.5,16 c-1.8,0-3.5-0.3-5.1-0.8v-50.6h2.6v19.6c0.8-0.1,1.7-0.2,2.5-0.2C275.9,197.9,283.2,205.1,283.2,213.9z M280.7,213.9 c0-8.1-6.2-14.7-13.9-14.7c-0.9,0-1.7,0.1-2.5,0.3v29c0.8,0.2,1.7,0.3,2.5,0.3C274.5,228.6,280.7,222,280.7,213.9z M289.9,229.1 h-2.6v-50.6h2.6V229.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054232333012241559850000006478839045768705965_",
    gradientUnits: "userSpaceOnUse",
    x1: 303.75,
    y1: 116.1756,
    x2: 303.75,
    y2: 171.1756,
    gradientTransform: "matrix(1 0 0 -1 0 345.2756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817116,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5637,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7C8AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054232333012241559850000006478839045768705965_)"
    },
    d: "M314.5,178.5v50.6H312v-44.2l-16.4,41.2 l-1.2,3H293v-50.6h2.6v44.2L305,199l0,0l7-17.5l1.2-3H314.5z M299.7,174.1h9.2c-0.4,0.4-0.7,0.8-1.1,1.2h-9.2 C299,174.9,299.3,174.5,299.7,174.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097500700589985545880000009923614652479056063_",
    gradientUnits: "userSpaceOnUse",
    x1: 345.65,
    y1: 116.1756,
    x2: 345.65,
    y2: 166.7756,
    gradientTransform: "matrix(1 0 0 -1 0 345.2756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817116,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5637,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7C8AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097500700589985545880000009923614652479056063_)"
    },
    d: "M334.9,229.1v-50.6c7.2,0,14.4,0,21.5,0 v50.6h-2.5v-49.4h-16.4v49.4H334.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171684311315269352520000008088488953915294642_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.3,
    y1: 116.1756,
    x2: 370.3,
    y2: 167.5756,
    gradientTransform: "matrix(1 0 0 -1 0 345.2756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817116,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5637,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7C8AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171684311315269352520000008088488953915294642_)"
    },
    d: "M364.6,209.7c-0.9,0-1.7-0.1-2.5-0.2 v19.6h-2.6v-50.6c1.6-0.5,3.3-0.8,5.1-0.8c9.1,0,16.5,7.2,16.5,16S373.7,209.7,364.6,209.7z M364.6,178.9c-0.9,0-1.7,0.1-2.5,0.3 v29c0.8,0.2,1.7,0.3,2.5,0.3c7.7,0,13.9-6.6,13.9-14.7C378.5,185.6,372.3,178.9,364.6,178.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178199679009007861240000017493969173903005072_",
    gradientUnits: "userSpaceOnUse",
    x1: 411,
    y1: 115.3756,
    x2: 411,
    y2: 167.5756,
    gradientTransform: "matrix(1 0 0 -1 0 345.2756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817116,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5637,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7C8AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178199679009007861240000017493969173903005072_)"
    },
    d: "M437.9,203.8c0,14.4-12,26.1-26.9,26.1 s-26.9-11.7-26.9-26.1s12-26.1,26.9-26.1S437.9,189.4,437.9,203.8z M428.2,187.1c-10-9.7-25.8-10.1-35.3-0.9 c-9.5,9.2-9.1,24.6,0.9,34.3s25.8,10.1,35.3,0.9C438.6,212.1,438.2,196.8,428.2,187.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157279063710317146810000002983478915953854361_",
    gradientUnits: "userSpaceOnUse",
    x1: 451.8,
    y1: 116.1756,
    x2: 451.8,
    y2: 167.5756,
    gradientTransform: "matrix(1 0 0 -1 0 345.2756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817116,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5637,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7C8AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157279063710317146810000002983478915953854361_)"
    },
    d: "M446.1,209.7c-0.9,0-1.7-0.1-2.5-0.2 v19.6H441v-50.6c1.6-0.5,3.3-0.8,5.1-0.8c9.1,0,16.5,7.2,16.5,16S455.2,209.7,446.1,209.7z M446.1,178.9c-0.9,0-1.7,0.1-2.5,0.3 v29c0.8,0.2,1.7,0.3,2.5,0.3c7.7,0,13.9-6.6,13.9-14.7C460,185.6,453.8,178.9,446.1,178.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119825907470228916100000006035139119861762453_",
    gradientUnits: "userSpaceOnUse",
    x1: 479.75,
    y1: 115.3756,
    x2: 479.75,
    y2: 166.7756,
    gradientTransform: "matrix(1 0 0 -1 0 345.2756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817116,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5637,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7C8AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119825907470228916100000006035139119861762453_)"
    },
    d: "M487.2,213.9c0,8.8-7.4,16-16.5,16 c-1.8,0-3.5-0.3-5.1-0.8v-50.6h2.6v19.6c0.8-0.1,1.7-0.2,2.5-0.2C479.9,197.9,487.2,205.1,487.2,213.9z M484.7,213.9 c0-8.1-6.2-14.7-13.9-14.7c-0.9,0-1.7,0.1-2.5,0.3v29c0.8,0.2,1.7,0.3,2.5,0.3C478.4,228.6,484.7,222,484.7,213.9z M493.9,229.1 h-2.6v-50.6h2.6V229.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034056284798764757420000001927264758524647047_",
    gradientUnits: "userSpaceOnUse",
    x1: 507.7,
    y1: 115.3756,
    x2: 507.7,
    y2: 167.5543,
    gradientTransform: "matrix(1 0 0 -1 0 345.2756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817116,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5637,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7C8AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034056284798764757420000001927264758524647047_)"
    },
    d: "M518.5,213.9c0,8.8-7.4,16-16.5,16 c-1.8,0-3.5-0.3-5.1-0.8l0,0v-50.2c0.3-0.2,0.7-0.3,1-0.5c1.3-0.5,2.7-0.8,4.1-0.8c6.1,0,11.1,4.8,11.1,10.7 c0,4.1-2.4,7.7-5.9,9.5c-0.4,0.2-0.7,0.3-1.1,0.5c0.8,0.2,1.6,0.4,2.3,0.7C514.4,201.6,518.5,207.3,518.5,213.9z M499.5,197.9h2.6 c4.7,0,8.5-4.3,8.5-9.5s-3.8-9.5-8.5-9.5c-0.9,0-1.8,0.2-2.6,0.4V197.9z M516,213.9c0-8.1-6.2-14.7-13.9-14.7h-2.6v29.2 c0.8,0.2,1.7,0.3,2.6,0.3C509.8,228.6,516,222,516,213.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091730626469343757510000016499584260666942652_",
    gradientUnits: "userSpaceOnUse",
    x1: -1117.9384,
    y1: -1098.0159,
    x2: -1037.6383,
    y2: -1098.0159,
    gradientTransform: "matrix(0 -1 -1 0 -868.916 -975.6383)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817116,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5637,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7C8AF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000091730626469343757510000016499584260666942652_)"
    },
    points: "171.9,62 206.1,62 286.3,142.3  252.2,142.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152954967262842578320000003912722614130406567_",
    gradientUnits: "userSpaceOnUse",
    x1: -1117.9384,
    y1: -1166.116,
    x2: -1037.6383,
    y2: -1166.116,
    gradientTransform: "matrix(0 -1 -1 0 -868.916 -975.6383)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817116,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5637,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7C8AF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000152954967262842578320000003912722614130406567_)"
    },
    points: "240,62 274.1,62 354.4,142.3  320.2,142.3  "
  })), /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "171.9,28.1 206.1,28.1 286.3,108.4 252.2,108.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075865331384016708590000009191138760799482021_",
    gradientUnits: "userSpaceOnUse",
    x1: -1084.0383,
    y1: -1166.116,
    x2: -1003.7383,
    y2: -1166.116,
    gradientTransform: "matrix(0 -1 -1 0 -868.916 -975.6383)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817116,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5637,
    style: {
      stopColor: "#E7C8AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7C8AF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000075865331384016708590000009191138760799482021_)"
    },
    points: "240,28.1 274.1,28.1  354.4,108.4 320.2,108.4  "
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M141.6,254.5v14.3h-1.2v-10.3c0-0.4,0-0.8,0-1.1c0-0.4,0-0.7,0-1.1h-0.1l-5.2,12.6H134l-5.2-12.6h-0.1c0,0.4,0,0.8,0,1.1 c0,0.4,0,0.8,0,1.2v10.2h-1.3v-14.3h1.8l5.2,12.7l5.2-12.7H141.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.3,254.2c1.2,0,2.2,0.3,3.1,0.9s1.4,1.4,1.8,2.3c0.4,1,0.6,2.1,0.6,3.4v1h-10.3c0,2,0.5,3.5,1.4,4.5 c0.9,1.1,2.2,1.6,3.9,1.6c0.9,0,1.7-0.1,2.3-0.2c0.7-0.1,1.4-0.4,2.2-0.7v1.2c-0.7,0.3-1.4,0.5-2.1,0.7c-0.7,0.1-1.5,0.2-2.4,0.2 c-1.5,0-2.7-0.3-3.6-0.9c-1-0.6-1.7-1.5-2.2-2.6c-0.5-1.1-0.7-2.4-0.7-3.8c0-1.4,0.2-2.7,0.7-3.9c0.5-1.1,1.2-2,2.1-2.7 C148.8,254.5,150,254.2,151.3,254.2z M151.3,255.3c-1.4,0-2.5,0.5-3.3,1.4c-0.8,0.9-1.3,2.2-1.5,3.9h8.9c0-1-0.1-2-0.4-2.8 c-0.3-0.8-0.7-1.4-1.4-1.9C153,255.6,152.2,255.3,151.3,255.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.6,254.5l-6.2,7l6.7,7.3h-1.6l-6.6-7.3v7.3h-1.3v-7.3l-6.6,7.3h-1.6l6.7-7.3l-6.3-7h1.6l6.2,7v-7h1.3v7l6.2-7H175.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.5,254.5v13.2h1.9v6h-1.3v-4.9h-11v4.9h-1.3v-6h1c0.8-1.1,1.5-2.4,2-3.7s1-2.8,1.2-4.4c0.3-1.6,0.4-3.2,0.5-5H188.5z  M187.2,255.6h-4.4c-0.1,1.6-0.2,3.1-0.5,4.5c-0.3,1.4-0.7,2.8-1.2,4c-0.5,1.3-1.1,2.4-1.8,3.5h7.9V255.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,254.5h1.4l3.5,9.1c0.2,0.5,0.4,1,0.6,1.5c0.2,0.5,0.3,0.9,0.4,1.2c0.1,0.4,0.2,0.7,0.3,1h0.1c0.1-0.4,0.3-0.9,0.5-1.6 c0.2-0.6,0.5-1.3,0.8-2.1l3.4-9.1h1.4l-6.5,17c-0.3,0.8-0.7,1.5-1,2.1c-0.4,0.6-0.8,1-1.3,1.3c-0.5,0.3-1.1,0.4-1.8,0.4 c-0.3,0-0.6,0-0.9-0.1c-0.3,0-0.5-0.1-0.8-0.2v-1.1c0.2,0.1,0.5,0.1,0.7,0.2c0.2,0,0.5,0.1,0.8,0.1c0.5,0,0.9-0.1,1.3-0.3 c0.4-0.2,0.7-0.5,1-1s0.6-1,0.8-1.6l1-2.5L191,254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.2,254.5v6.3h9v-6.3h1.3v14.3h-1.3v-6.9h-9v6.9h-1.3v-14.3H207.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.3,254.2c1.6,0,2.8,0.4,3.5,1.2c0.8,0.8,1.2,2.1,1.2,3.8v9.6h-1l-0.2-2.5h-0.1c-0.3,0.5-0.7,1-1.1,1.4 c-0.4,0.4-1,0.7-1.6,1c-0.6,0.2-1.4,0.4-2.3,0.4c-0.9,0-1.7-0.2-2.4-0.5c-0.7-0.3-1.2-0.8-1.5-1.3c-0.4-0.6-0.5-1.3-0.5-2.1 c0-1.4,0.6-2.5,1.8-3.2c1.2-0.7,2.9-1.2,5.1-1.3l2.7-0.1v-1c0-1.5-0.3-2.5-0.9-3.1c-0.6-0.6-1.4-0.9-2.6-0.9 c-0.7,0-1.4,0.1-2.1,0.3c-0.7,0.2-1.4,0.5-2.1,0.8l-0.4-1.1c0.7-0.3,1.4-0.6,2.2-0.8C225.6,254.3,226.4,254.2,227.3,254.2z  M230.7,261.5l-2.5,0.1c-1.8,0.1-3.2,0.4-4.2,1s-1.4,1.4-1.4,2.5c0,0.9,0.3,1.6,0.9,2.1c0.6,0.5,1.4,0.7,2.4,0.7 c1.6,0,2.8-0.4,3.6-1.3c0.8-0.9,1.2-2.1,1.3-3.7V261.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,254.2c1.8,0,3.3,0.6,4.3,1.9c1,1.2,1.5,3.1,1.5,5.5c0,1.6-0.2,3-0.7,4.1c-0.5,1.1-1.2,2-2.1,2.6s-2,0.9-3.2,0.9 c-0.9,0-1.6-0.1-2.2-0.4c-0.6-0.3-1.2-0.6-1.6-1.1c-0.4-0.4-0.7-0.9-1-1.5h-0.1c0,0.5,0,1,0.1,1.6s0,1.1,0,1.5v5.9h-1.3v-20.7h1.1 l0.2,2.9h0.1c0.2-0.5,0.6-1.1,1-1.5c0.4-0.5,1-0.9,1.6-1.2C241.2,254.3,242,254.2,243,254.2z M242.8,255.4c-1.1,0-2,0.2-2.7,0.7 c-0.7,0.5-1.2,1.2-1.6,2.1c-0.3,0.9-0.5,2-0.5,3.3v0.2c0,1.4,0.2,2.6,0.5,3.5c0.3,0.9,0.9,1.6,1.6,2.1c0.7,0.5,1.6,0.7,2.6,0.7 c1,0,1.9-0.2,2.6-0.8c0.7-0.5,1.2-1.2,1.6-2.2s0.6-2.1,0.6-3.5c0-2-0.4-3.5-1.2-4.6C245.5,255.9,244.3,255.4,242.8,255.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.6,261.6c0,1.1-0.1,2.1-0.4,3c-0.3,0.9-0.7,1.7-1.2,2.4c-0.5,0.7-1.2,1.2-2,1.5c-0.8,0.4-1.7,0.5-2.8,0.5 c-1,0-1.9-0.2-2.7-0.5c-0.8-0.4-1.4-0.9-2-1.5c-0.5-0.7-1-1.4-1.2-2.4c-0.3-0.9-0.4-1.9-0.4-3c0-1.5,0.3-2.9,0.8-4 c0.5-1.1,1.3-2,2.2-2.6c1-0.6,2.1-0.9,3.5-0.9c1.4,0,2.5,0.3,3.5,0.9c0.9,0.6,1.6,1.5,2.1,2.6S264.6,260.2,264.6,261.6z  M253.2,261.6c0,1.3,0.2,2.4,0.5,3.3s0.9,1.7,1.6,2.2s1.7,0.8,2.8,0.8c1.2,0,2.1-0.3,2.8-0.8s1.3-1.3,1.6-2.2s0.5-2,0.5-3.3 c0-1.2-0.2-2.3-0.5-3.2c-0.3-0.9-0.9-1.7-1.6-2.2c-0.7-0.5-1.7-0.8-2.8-0.8c-1.7,0-2.9,0.6-3.8,1.7 C253.6,258.1,253.2,259.7,253.2,261.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.3,254.5v13.2h1.9v6h-1.3v-4.9h-11v4.9h-1.3v-6h1c0.8-1.1,1.5-2.4,2-3.7s1-2.8,1.2-4.4c0.3-1.6,0.4-3.2,0.5-5H278.3z  M277,255.6h-4.4c-0.1,1.6-0.2,3.1-0.5,4.5c-0.3,1.4-0.7,2.8-1.2,4c-0.5,1.3-1.1,2.4-1.8,3.5h7.9V255.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.6,254.5v6.3h9v-6.3h1.3v14.3h-1.3v-6.9h-9v6.9h-1.3v-14.3H284.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.7,254.2c1.6,0,2.8,0.4,3.5,1.2c0.8,0.8,1.2,2.1,1.2,3.8v9.6h-1l-0.2-2.5h-0.1c-0.3,0.5-0.7,1-1.1,1.4 c-0.4,0.4-1,0.7-1.6,1c-0.6,0.2-1.4,0.4-2.3,0.4c-0.9,0-1.7-0.2-2.4-0.5c-0.7-0.3-1.2-0.8-1.5-1.3c-0.4-0.6-0.5-1.3-0.5-2.1 c0-1.4,0.6-2.5,1.8-3.2c1.2-0.7,2.9-1.2,5.1-1.3l2.7-0.1v-1c0-1.5-0.3-2.5-0.9-3.1c-0.6-0.6-1.4-0.9-2.6-0.9 c-0.7,0-1.4,0.1-2.1,0.3c-0.7,0.2-1.4,0.5-2.1,0.8l-0.4-1.1c0.7-0.3,1.4-0.6,2.2-0.8C303.1,254.3,303.9,254.2,304.7,254.2z  M308.1,261.5l-2.5,0.1c-1.8,0.1-3.2,0.4-4.2,1s-1.4,1.4-1.4,2.5c0,0.9,0.3,1.6,0.9,2.1c0.6,0.5,1.4,0.7,2.4,0.7 c1.6,0,2.8-0.4,3.6-1.3c0.8-0.9,1.2-2.1,1.3-3.7V261.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.8,268.8h-1.6l4.3-6.2c-0.8-0.1-1.5-0.3-2-0.6s-1-0.8-1.3-1.3c-0.3-0.6-0.4-1.2-0.4-2c0-1.4,0.4-2.5,1.3-3.2 c0.9-0.7,2-1,3.5-1h5.9v14.3h-1.3v-6h-4.3L313.8,268.8z M314.1,258.6c0,1,0.3,1.7,0.9,2.2c0.6,0.5,1.5,0.7,2.8,0.7h4.4v-6h-4.4 c-1.2,0-2.1,0.3-2.7,0.8C314.4,257,314.1,257.7,314.1,258.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.8,254.5v14.3h-1.3v-13.2h-8.8v13.2h-1.3v-14.3H346.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.9,254.2c1.8,0,3.3,0.6,4.3,1.9c1,1.2,1.5,3.1,1.5,5.5c0,1.6-0.2,3-0.7,4.1c-0.5,1.1-1.2,2-2.1,2.6 c-0.9,0.6-2,0.9-3.2,0.9c-0.9,0-1.6-0.1-2.2-0.4c-0.6-0.3-1.2-0.6-1.6-1.1c-0.4-0.4-0.7-0.9-1-1.5h-0.1c0,0.5,0,1,0.1,1.6 c0,0.5,0,1.1,0,1.5v5.9h-1.3v-20.7h1.1l0.2,2.9h0.1c0.2-0.5,0.6-1.1,1-1.5c0.4-0.5,1-0.9,1.6-1.2 C356.2,254.3,357,254.2,357.9,254.2z M357.8,255.4c-1.1,0-2,0.2-2.7,0.7c-0.7,0.5-1.2,1.2-1.6,2.1c-0.3,0.9-0.5,2-0.5,3.3v0.2 c0,1.4,0.2,2.6,0.5,3.5c0.3,0.9,0.9,1.6,1.6,2.1c0.7,0.5,1.6,0.7,2.6,0.7c1,0,1.9-0.2,2.6-0.8c0.7-0.5,1.2-1.2,1.6-2.2 s0.6-2.1,0.6-3.5c0-2-0.4-3.5-1.2-4.6C360.4,255.9,359.3,255.4,357.8,255.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.1,254.2c1.2,0,2.2,0.3,3.1,0.9c0.8,0.6,1.4,1.4,1.8,2.3c0.4,1,0.6,2.1,0.6,3.4v1h-10.3c0,2,0.5,3.5,1.4,4.5 c0.9,1.1,2.2,1.6,3.9,1.6c0.9,0,1.7-0.1,2.3-0.2c0.7-0.1,1.4-0.4,2.2-0.7v1.2c-0.7,0.3-1.4,0.5-2.1,0.7c-0.7,0.1-1.5,0.2-2.4,0.2 c-1.4,0-2.7-0.3-3.6-0.9c-1-0.6-1.7-1.5-2.2-2.6c-0.5-1.1-0.7-2.4-0.7-3.8c0-1.4,0.2-2.7,0.7-3.9c0.5-1.1,1.2-2,2.1-2.7 C370.6,254.5,371.7,254.2,373.1,254.2z M373.1,255.3c-1.4,0-2.5,0.5-3.3,1.4c-0.8,0.9-1.3,2.2-1.5,3.9h8.9c0-1-0.1-2-0.4-2.8 c-0.3-0.8-0.7-1.4-1.4-1.9C374.8,255.6,374,255.3,373.1,255.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.4,254.5v14.3h-1.2v-10.3c0-0.4,0-0.8,0-1.1c0-0.4,0-0.7,0-1.1h-0.1l-5.2,12.6h-1.2l-5.2-12.6h-0.1c0,0.4,0,0.8,0,1.1 c0,0.4,0,0.8,0,1.2v10.2h-1.3v-14.3h1.8l5.2,12.7l5.2-12.7H396.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,254.5v10.3c0,0.2,0,0.4,0,0.6c0,0.2,0,0.4,0,0.6c0,0.2,0,0.4,0,0.6s0,0.4,0,0.6l8.6-12.8h1.6v14.3h-1.3v-10.4 c0-0.3,0-0.5,0-0.8c0-0.3,0-0.6,0-0.9c0-0.3,0-0.6,0-0.8l-8.6,12.9h-1.6v-14.3H402z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.6,268.8H415l4.3-6.2c-0.8-0.1-1.5-0.3-2-0.6s-1-0.8-1.3-1.3c-0.3-0.6-0.4-1.2-0.4-2c0-1.4,0.4-2.5,1.3-3.2 c0.9-0.7,2-1,3.5-1h5.9v14.3h-1.3v-6h-4.3L416.6,268.8z M417,258.6c0,1,0.3,1.7,0.9,2.2c0.6,0.5,1.5,0.7,2.8,0.7h4.4v-6h-4.4 c-1.2,0-2.1,0.3-2.7,0.8C417.3,257,417,257.7,417,258.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bbcd4758092a5d37adae0e71d2bdfafd.svg";
export { ForwardRef as ReactComponent };